<template>
  <base-card class="p-2">
    <p class="page-indicator text-center">{{ currentPage }} of 4</p>
    <slot></slot>
  </base-card>
</template>

<script>
export default {
  name: 'HealthStatusViewItem',
  props: {
    currentPage: Number,
  },
  components: {
    BaseCard: () => import('@/components/base-card/base-card.vue'),
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
